export class MainModel {
  CampaignId?: string;
  CandidateId?: string;

  constructor(campaignId?: string, candidateId?: string) {
    this.CampaignId = campaignId;
    this.CandidateId = candidateId;
  }
}
